import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AuthService]
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;

  constructor(public auth: AuthService, private router: Router) { }

  ngOnInit() {
  }

  login(email: string, password: string) {
    this.auth.login(email, password);
  }

}



// WEBPACK FOOTER //
// ./src/app/users/login/login.component.ts